import React from "react";
import PropTypes from "prop-types";

import { UIStatusTag } from "../../../ui";
import { TIMESHEET_APPLICANT_STATUSES } from "./constants";

const STATUS_TONE_BY_VALUE = {
  [TIMESHEET_APPLICANT_STATUSES.approved]: "successSoft",
  [TIMESHEET_APPLICANT_STATUSES.removed]: "destructiveSoft",
  [TIMESHEET_APPLICANT_STATUSES.cancelled]: "destructiveSoft",
  pending: "warningSoft",
  rejected: "destructiveSoft",
  auto_cancelled: "destructiveSoft",
};

const TimesheetApplicantStatusBadge = ({ status, label }) => (
  <UIStatusTag
    status={status}
    label={label}
    tone={STATUS_TONE_BY_VALUE[status]}
    preset="table"
  />
);

TimesheetApplicantStatusBadge.propTypes = {
  status: PropTypes.string,
  label: PropTypes.node.isRequired,
};

export default TimesheetApplicantStatusBadge;
